/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Self_Organize_YouInputs */



/**
* | output |
* | --- |
* | "You" |
*
* @param {Self_Organize_YouInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const self_organize_you = /** @type {((inputs?: Self_Organize_YouInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Self_Organize_YouInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous")
	if (locale === "es") return /** @type {LocalizedString} */ ("Usted")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tu")
	return /** @type {LocalizedString} */ ("You")
});